export const METADATA_ACTION_DIALOG_COPY = {
  restore: {
    actionLabel: "Restore original metadata",
    title: "Restore original metadata?",
    confirmLabel: "Restore metadata",
    descriptionPrefix:
      "This will replace current metadata edits with the original values from",
    destructive: false,
  },
  clear: {
    actionLabel: "Clear all metadata",
    title: "Clear all metadata?",
    confirmLabel: "Clear metadata",
    descriptionPrefix: "This will remove all editable metadata values from",
    destructive: true,
  },
};

export function getScopeText(selectionCount) {
  return selectionCount === 1 ? "this file" : "the selected files";
}

export function getMetadataActionDialogText(action, selectionCount) {
  const actionCopy = METADATA_ACTION_DIALOG_COPY[action];
  if (!actionCopy) return null;

  return {
    ...actionCopy,
    description: `${actionCopy.descriptionPrefix} ${getScopeText(selectionCount)}. You can undo this action.`,
  };
}
